module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-honda-24.dc0dac05.jpg";